import VueElement from './vue'

export default class Dropdown extends VueElement {
  static vueComponent = 'dropdown-menu'

  get props () {
    return {
      label: this.getAttribute('label'),
      options: JSON.parse(this.getAttribute('options'))
    }
  }
}
